import {put} from "redux-saga/effects";

import axios from "../../../../../api/axios"

import * as actions from "../../../../actions";
import * as api from "../../../../../api";
import {generateDynamicRoute} from "../../../../../utils/utils";

export function* adminUtilisateursSupprimerUtilisateurSaga (action) {

    yield put(actions.adminUtilisateursSupprimerUtilisateurStart());

    const utilisateur = action.payload.utilisateur;

    try {
        const response = yield axios.delete(generateDynamicRoute(api.supprimerUtilisateur,[{toReplace:":utilisateurId",value:utilisateur}]));
        yield put(actions.adminUtilisateursSupprimerUtilisateurSuccess(response.data));
    } catch (error) {
        if(error.response) {
            yield put(actions.adminUtilisateursSupprimerUtilisateurFail(error.response.data.error));
        }else {
            yield put(actions.adminUtilisateursSupprimerUtilisateurFail("There's an error!"));
        }
    }
}

